import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function uniqueValidator(items: any[], property: string, idObj: { key: string, value?: number }): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || items.some(i => i[property] === control.value && (!idObj.value || i[idObj.key] !== idObj.value))) {
      return { unique: { value: control.value } };
    }

    return null;
  };
}
